module.exports = __webpack_public_path__ + "static/media/cq_inoltra_documento b.fb664041.svg";